import AppWaldenViewRoute from '../walden-view';

export default class AppServicesWaldenViewRefRoute extends AppWaldenViewRoute {}
